"use client";
//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Col, Row, Space, Skeleton, Typography } from "antd";
import Cookies from "js-cookie";

//? Assets --------------------------------------------------------------------->
import { ArrowLeftOutlined } from "@ant-design/icons";
import Coins from "../../../assets/images/AccountsPage/Coins.svg";
import MySLogo from "../../../assets/images/logos/MySWalletLogo.svg";

//? Modules -------------------------------------------------------------------->
// import WishlistCard from "./WishlistCard/WishlistCard";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
import AccountStatus from "@/functions/Cookies/Cookies";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function Wallet({ setActiveMenu }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const {
    loggedIn,
    comverse_customer_id,
    comverse_customer_email,
    comverse_customer_token,
  } = AccountStatus();

  //? Redux States --------------------------------------------------------------->
  const cookiesCurrency = Cookies.get("defaultCurrencyName");

  const defaultCurrency = cookiesCurrency;

  const [WalletPoints, setWalletPoints] = useState({});
  const [WalletHistory, setWalletHistory] = useState({});

  const fetchWalletPoints = useCallback(async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const payload = {
        method: "GET",
        headers: headers,
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/get_wallet_balance",
        payload
      );

      const data = await res.json();

      if (!res.ok) {
        if (data?.detail === "Invalid auth token") {
          customerLogout();
          dispatch(logoutReducer());
          router.push("/login");
        }
        //logout here
        throw new Error("Api Failed!");
      }

      setWalletPoints(data);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      return null;
    }
  }, [comverse_customer_token]);

  const fetchWalletHistory = useCallback(async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      if (comverse_customer_token) {
        headers.Authorization = comverse_customer_token;
      }

      const payload = {
        method: "GET",
        headers: headers,
      };

      const res = await fetch(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/get_wallet_history",
        payload
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error("Api Failed!");
      }

      setWalletHistory(data);
      return data;
    } catch (error) {
      console.error("Error fetching data:", error.message);
      return null;
    }
  }, [comverse_customer_token]);

  useEffect(() => {
    if (comverse_customer_token) {
      fetchWalletPoints();
    }
  }, [comverse_customer_token, fetchWalletPoints]);

  useEffect(() => {
    if (comverse_customer_token) {
      fetchWalletHistory();
    }
  }, [comverse_customer_token, fetchWalletHistory]);

  return (
    <Col className="WalletHistory padding20">
      <Space size="middle">
        <Col
          className="flexCenter cursorPointer"
          onClick={() => setActiveMenu("dashboard")}
          style={{ background: "#FFFFFF", width: "29px", height: "30px" }}
        >
          <ArrowLeftOutlined />
        </Col>
        <Text className="font18">My Wallet</Text>
      </Space>

      {/* style={{ minHeight: "515px" }} */}

      <Col className="marginTop15">
        <Row className="gap10">
          <Col span={24}>
            <Row className="gap15">
              <Col flex="0 0 auto" className="walletCard">
                <Space className="width100 flexBetween">
                  <Space direction="vertical">
                    <Image
                      src={MySLogo}
                      width="100%"
                      height="auto"
                      alt="MySLogo"
                      preview={false}
                    />

                    <Text className="font18" style={{ color: "#FFFFFF" }}>
                      Total Balance
                    </Text>
                    <Text
                      style={{
                        fontSize: "36px",
                        color: "#FFFFFF",
                      }}
                    >
                      {WalletPoints?.wallet_points
                        ? WalletPoints?.wallet_points
                        : 0}
                      &nbsp;
                      {defaultCurrency}
                    </Text>
                  </Space>
                  <Image
                    src={Coins}
                    width="100%"
                    height="auto"
                    alt="Coins"
                    preview={false}
                  />
                </Space>
              </Col>
            </Row>
          </Col>

          {WalletHistory?.results?.length > 0 ? (
            <Col
              span={24}
              className="RewardTable marginTop30 padding20 backgroundLight"
            >
              <Row>
                <Col
                  flex="33%"
                  className="font18Bold poppinsMedium paddingLeft20"
                >
                  No
                </Col>
                <Col flex="33%" className="font18Bold poppinsMedium">
                  Date
                </Col>
                <Col flex="33%" className="font18Bold poppinsMedium">
                  Added/Deducted
                </Col>
              </Row>

              <Col span={24} className="marginTop10">
                {WalletHistory?.results?.map((result, index) => {
                  return (
                    <Row
                      key={index}
                      className={
                        index % 2 === 0 ? "tableRow rowColor" : "tableRow"
                      }
                    >
                      <Col flex="33%" className="alignCenter paddingLeft20">
                        {result?.id}
                      </Col>
                      <Col flex="33%" className="alignCenter">
                        {result?.created_at ? result?.created_at : "N/A"}
                      </Col>
                      <Col flex="33%" className="alignCenter">
                        {defaultCurrency}&nbsp;
                        {result?.value ? result?.value : 0}
                      </Col>
                    </Row>
                  );
                })}

                {WalletHistory?.next ? (
                  <DynamicButton
                    type="primary"
                    name="Load More"
                    property="danger"
                    className="primary_btn_outline loadMore"
                  // function={() => fetchSimilarProducts()}
                  />
                ) : null}
              </Col>
            </Col>
          ) : null}
        </Row>
      </Col>
    </Col>
  );
}
